export default __webpack_public_path__ + "static/media/mobile_only_v2.0ba1a276.jpg";